module.exports = "agm-map{height:300px}\n"